import type { Location, NodeEntry } from 'slate';
import { Editor } from 'slate';

import type { ImageElement } from '../internal';
import { isDrawingElement, isImageElement, Queries } from '../internal';

export const imageQueries = {
  /**
   * Returns the correct dimensions of an image (drawing or signature) element.
   */
  getImageDimensions(node: ImageElement): {
    heightPx: number;
    widthPx: number;
  } {
    if (isDrawingElement(node)) {
      const dimensions = Queries.getDrawingDimensions(node);
      return {
        heightPx: dimensions.containerHeightPx,
        widthPx: dimensions.containerWidthPx,
      };
    }

    const dimensions = Queries.getSignatureImageDimensions(node);
    return {
      heightPx: dimensions.imgHeightPx,
      widthPx: dimensions.imgWidthPx,
    };
  },

  /**
   * Get all image node entries at a Location.
   * Optional `filter` predicate can be used to further filter the results.
   */
  getImageEntries(
    editor: Editor,
    options: {
      at?: Location;
      filter?: (node: ImageElement) => boolean;
    }
  ): NodeEntry<ImageElement>[] {
    const { at = editor.selection, filter = () => true } = options;
    if (!at) return [];

    return [
      ...Editor.nodes<ImageElement>(editor, {
        at,
        match: n => isImageElement(n) && filter(n),
        voids: true,
      }),
    ];
  },
};
